function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * chartjs-chart-wordcloud
 * https://github.com/sgratzl/chartjs-chart-wordcloud
 *
 * Copyright (c) 2019 Samuel Gratzl <sam@sgratzl.com>
 */

import { Element, registry, DatasetController, Chart } from 'chart.js';
import { toFont } from 'chart.js/helpers';
import layout from 'd3-cloud';
var WordElement = /*#__PURE__*/function (_Element) {
  _inherits(WordElement, _Element);
  function WordElement() {
    _classCallCheck(this, WordElement);
    return _callSuper(this, WordElement, arguments);
  }
  _createClass(WordElement, [{
    key: "inRange",
    value: function inRange(mouseX, mouseY) {
      var p = this.getProps(['x', 'y', 'width', 'height', 'scale']);
      if (p.scale <= 0) {
        return false;
      }
      var x = Number.isNaN(mouseX) ? p.x : mouseX;
      var y = Number.isNaN(mouseY) ? p.y : mouseY;
      return x >= p.x - p.width / 2 && x <= p.x + p.width / 2 && y >= p.y - p.height / 2 && y <= p.y + p.height / 2;
    }
  }, {
    key: "inXRange",
    value: function inXRange(mouseX) {
      return this.inRange(mouseX, Number.NaN);
    }
  }, {
    key: "inYRange",
    value: function inYRange(mouseY) {
      return this.inRange(Number.NaN, mouseY);
    }
  }, {
    key: "getCenterPoint",
    value: function getCenterPoint() {
      return this.getProps(['x', 'y']);
    }
  }, {
    key: "tooltipPosition",
    value: function tooltipPosition() {
      return this.getCenterPoint();
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      var options = this.options;
      var props = this.getProps(['x', 'y', 'width', 'height', 'text', 'scale']);
      if (props.scale <= 0) {
        return;
      }
      ctx.save();
      var f = toFont(_objectSpread(_objectSpread({}, options), {}, {
        size: options.size * props.scale
      }));
      ctx.font = f.string;
      ctx.fillStyle = options.color;
      ctx.textAlign = 'center';
      ctx.translate(props.x, props.y);
      ctx.rotate(options.rotate / 180 * Math.PI);
      if (options.strokeStyle) {
        ctx.strokeStyle = options.strokeStyle;
        ctx.strokeText(props.text, 0, 0);
      }
      ctx.fillText(props.text, 0, 0);
      ctx.restore();
    }
  }], [{
    key: "computeRotation",
    value: function computeRotation(o, rnd) {
      if (o.rotationSteps <= 1) {
        return 0;
      }
      if (o.minRotation === o.maxRotation) {
        return o.minRotation;
      }
      var base = Math.min(o.rotationSteps, Math.floor(rnd() * o.rotationSteps)) / (o.rotationSteps - 1);
      var range = o.maxRotation - o.minRotation;
      return o.minRotation + base * range;
    }
  }]);
  return WordElement;
}(Element);
WordElement.id = 'word';
WordElement.defaults = {
  minRotation: -90,
  maxRotation: 0,
  rotationSteps: 2,
  padding: 1,
  strokeStyle: undefined,
  size: function size(ctx) {
    var v = ctx.parsed.y;
    return v;
  },
  hoverColor: '#ababab'
};
WordElement.defaultRoutes = {
  color: 'color',
  family: 'font.family',
  style: 'font.style',
  weight: 'font.weight',
  lineHeight: 'font.lineHeight'
};
function patchController(type, config, controller) {
  var elements = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var scales = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  registry.addControllers(controller);
  if (Array.isArray(elements)) {
    registry.addElements.apply(registry, _toConsumableArray(elements));
  } else {
    registry.addElements(elements);
  }
  if (Array.isArray(scales)) {
    registry.addScales.apply(registry, _toConsumableArray(scales));
  } else {
    registry.addScales(scales);
  }
  var c = config;
  c.type = type;
  return c;
}
function rnd() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  var s = typeof seed === 'number' ? seed : Array.from(seed).reduce(function (acc, v) {
    return acc + v.charCodeAt(0);
  }, 0);
  return function () {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}
var WordCloudController = /*#__PURE__*/function (_DatasetController) {
  _inherits(WordCloudController, _DatasetController);
  function WordCloudController() {
    var _this;
    _classCallCheck(this, WordCloudController);
    _this = _callSuper(this, WordCloudController, arguments);
    _this.wordLayout = layout().text(function (d) {
      return d.text;
    }).padding(function (d) {
      return d.options.padding;
    }).rotate(function (d) {
      return d.options.rotate;
    }).font(function (d) {
      return d.options.family;
    }).fontSize(function (d) {
      return d.options.size;
    }).fontStyle(function (d) {
      return d.options.style;
    }).fontWeight(function (d) {
      var _a;
      return (_a = d.options.weight) !== null && _a !== void 0 ? _a : 1;
    });
    _this.rand = Math.random;
    return _this;
  }
  _createClass(WordCloudController, [{
    key: "update",
    value: function update(mode) {
      _get(_getPrototypeOf(WordCloudController.prototype), "update", this).call(this, mode);
      this.rand = rnd(this.chart.id);
      var meta = this._cachedMeta;
      var elems = meta.data || [];
      this.updateElements(elems, 0, elems.length, mode);
    }
  }, {
    key: "updateElements",
    value: function updateElements(elems, start, count, mode) {
      var _this2 = this;
      var _a, _b, _c, _d;
      this.wordLayout.stop();
      var xScale = this._cachedMeta.xScale;
      var yScale = this._cachedMeta.yScale;
      var w = xScale.right - xScale.left;
      var h = yScale.bottom - yScale.top;
      var labels = this.chart.data.labels;
      var words = [];
      for (var i = start; i < start + count; i += 1) {
        var o = this.resolveDataElementOptions(i, mode);
        if (o.rotate == null) {
          o.rotate = WordElement.computeRotation(o, this.rand);
        }
        var properties = {
          options: _objectSpread(_objectSpread({}, toFont(o)), o),
          x: (_b = (_a = this._cachedMeta.xScale) === null || _a === void 0 ? void 0 : _a.getPixelForDecimal(0.5)) !== null && _b !== void 0 ? _b : 0,
          y: (_d = (_c = this._cachedMeta.yScale) === null || _c === void 0 ? void 0 : _c.getPixelForDecimal(0.5)) !== null && _d !== void 0 ? _d : 0,
          width: 10,
          height: 10,
          scale: 1,
          index: i,
          text: labels[i]
        };
        words.push(properties);
      }
      if (mode === 'reset') {
        words.forEach(function (tag) {
          _this2.updateElement(elems[tag.index], tag.index, tag, mode);
        });
        return;
      }
      this.wordLayout.random(this.rand).words(words);
      var run = function run() {
        var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var tries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
        _this2.wordLayout.size([w * factor, h * factor]).on('end', function (tags, bounds) {
          if (tags.length < labels.length) {
            if (tries > 0) {
              run(factor * 1.2, tries - 1);
              return;
            }
            console.warn('cannot fit all text elements in three tries');
          }
          var wb = bounds[1].x - bounds[0].x;
          var hb = bounds[1].y - bounds[0].y;
          var dsOptions = _this2.options;
          var scale = dsOptions.fit ? Math.min(w / wb, h / hb) : 1;
          var indices = new Set(labels.map(function (_, i) {
            return i;
          }));
          tags.forEach(function (tag) {
            indices.delete(tag.index);
            _this2.updateElement(elems[tag.index], tag.index, {
              options: tag.options,
              scale: scale,
              x: xScale.left + scale * tag.x + w / 2,
              y: yScale.top + scale * tag.y + h / 2,
              width: scale * tag.width,
              height: scale * tag.height,
              text: tag.text
            }, mode);
          });
          indices.forEach(function (i) {
            return _this2.updateElement(elems[i], i, {
              scale: 0
            }, mode);
          });
        }).start();
      };
      run();
    }
  }, {
    key: "draw",
    value: function draw() {
      var elements = this._cachedMeta.data;
      var ctx = this.chart.ctx;
      elements.forEach(function (elem) {
        return elem.draw(ctx);
      });
    }
  }, {
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var r = _get(_getPrototypeOf(WordCloudController.prototype), "getLabelAndValue", this).call(this, index);
      var labels = this.chart.data.labels;
      r.label = labels[index];
      return r;
    }
  }]);
  return WordCloudController;
}(DatasetController);
WordCloudController.id = 'wordCloud';
WordCloudController.defaults = {
  datasets: {
    fit: true,
    animation: {
      colors: {
        properties: ['color', 'strokeStyle']
      },
      numbers: {
        properties: ['x', 'y', 'size', 'rotate']
      }
    }
  },
  maintainAspectRatio: false,
  dataElementType: WordElement.id
};
WordCloudController.overrides = {
  scales: {
    x: {
      type: 'linear',
      min: -1,
      max: 1,
      display: false
    },
    y: {
      type: 'linear',
      min: -1,
      max: 1,
      display: false
    }
  }
};
var WordCloudChart = /*#__PURE__*/function (_Chart) {
  _inherits(WordCloudChart, _Chart);
  function WordCloudChart(item, config) {
    _classCallCheck(this, WordCloudChart);
    return _callSuper(this, WordCloudChart, [item, patchController('wordCloud', config, WordCloudController, WordElement)]);
  }
  return _createClass(WordCloudChart);
}(Chart);
WordCloudChart.id = WordCloudController.id;
export { WordCloudChart, WordCloudController, WordElement };